export function GetRandomEnum<T>(sourceEnum: T): T[keyof T] {
    const enumValues = GetEnumValues(sourceEnum);
    const randomIndex = Math.floor(Math.random() * enumValues.length);
    const randomEnumValue = enumValues[randomIndex];
    return randomEnumValue;
}

export function GetEnumValues<TEnum>(sourceEnum: TEnum) {
    return Object.keys(sourceEnum as unknown as object)
        .map((n) => Number.parseInt(n))
        .filter((n) => !Number.isNaN(n)) as any as TEnum[keyof TEnum][];
}

export function GetEnumIndex<TEnum>(sourceEnum: TEnum, enumName: string) {
    var enumNames = GetEnumNames(sourceEnum);
    var result = enumNames.findIndex((name) => name === enumName);
    return result;
}

export function GetEnumElementByIndex<TEnum>(
    sourceEnum: TEnum,
    index: number
): TEnum[keyof TEnum] {
    const enumValues = GetEnumValues(sourceEnum);
    return enumValues[index];
}

export function GetEnumNames(sourceEnum: any): string[] {
    var names: string[] = [];
    const IsEnumString = (value: string) => parseInt(value) >= 0 === false;

    for (var value in sourceEnum) {
        if (IsEnumString(value)) {
            names.push(value);
        }
    }

    return names;
}

export function GetEnumElementFromString<TEnum>(
    sourceEnum: TEnum,
    enumName: string
) {
    const matchedEnumName = GetEnumNames(sourceEnum).find(
        (enumValue) => enumValue.toLowerCase() === enumName.toLowerCase()
    );

    if (matchedEnumName !== undefined) {
        const enumElement =
            sourceEnum[matchedEnumName as keyof typeof sourceEnum];

        return enumElement;
    }
}

export function GetPreviousEnumValue<TEnum>(
    sourceEnum: TEnum,
    currentValue: TEnum[keyof TEnum]
): TEnum[keyof TEnum] {
    const enumValues = GetEnumValues(sourceEnum);
    const currentIndex = enumValues.indexOf(currentValue);
    const previousIndex =
        (currentIndex - 1 + enumValues.length) % enumValues.length;
    return enumValues[previousIndex];
}

export function GetNextEnumValue<TEnum>(
    sourceEnum: TEnum,
    currentValue: TEnum[keyof TEnum]
): TEnum[keyof TEnum] {
    const enumValues = GetEnumValues(sourceEnum);
    const currentIndex = enumValues.indexOf(currentValue);
    const nextIndex = (currentIndex + 1) % enumValues.length;
    return enumValues[nextIndex];
}
